import styled from 'styled-components';
import { Col as GridCol } from 'react-grid-system';

// We want to preserve the public Col name
const Col = styled(GridCol)<{
  order: string;
}>`
  order: ${({ order }) => order};
`;
export { Col as StyledCol };
